import { render, staticRenderFns } from "./trinity.vue?vue&type=template&id=0cf6ec50&"
import script from "./trinity.vue?vue&type=script&lang=js&"
export * from "./trinity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports